import React from "react";

const AuthorityNavbar = () => {
  return <nav className="bg-gray-600 py-8 shadow-lg"></nav>;
};

export default AuthorityNavbar;
